import React from 'react';

const AdministrativeStaff = () => {
  return (
    <div>
      AdministrativeStaff
      AdministrativeStaff
    </div>
  );
}

export default AdministrativeStaff;
